import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SnConstantsAPI } from '@lib/api/services';
import { SnCurrentOrganization } from '@lib/auth';

@Component({
  selector: 'fs-sentry-schedule-dialog',
  templateUrl: './sentry-schedule-dialog.component.html',
  styleUrls: ['./sentry-schedule-dialog.component.scss'],
})
export class SentryScheduleDialogComponent implements OnInit, OnDestroy {
  public timezone: string;
  public timezoneOptions: string[];

  private _destroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _dialogRef: MatDialogRef<SentryScheduleDialogComponent>,
    private readonly _currentOrg: SnCurrentOrganization,
    private readonly _constantsAPI: SnConstantsAPI,
  ) {}

  public ngOnInit(): void {
    this.timezone = this.data.timezone || this._currentOrg.settings.timezone;
    this._constantsAPI
      .getTimezones()
      .pipe(takeUntil(this._destroy$))
      .subscribe((zones) => {
        this.timezoneOptions = Object.keys(zones);
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public cancel(): void {
    this._dialogRef.close();
  }

  public setSchedules(value: string[]): void {
    this._dialogRef.close({
      schedules: value,
      timezone: this.timezone,
    });
  }
}
